import React, { createContext, useRef, useContext } from 'react';

const PayUTokenizeContext = createContext(null);

export function PayUTokenizeProvider({ children }) {
  const tokenizeRef = useRef(null);

  const value = {
    tokenizeRef,
    registerTokenize: fn => {
      tokenizeRef.current = fn;
    },
    unregisterTokenize: () => {
      tokenizeRef.current = null;
    },
  };

  return (
    <PayUTokenizeContext.Provider value={value}>
      {children}
    </PayUTokenizeContext.Provider>
  );
}

export function usePayUTokenize() {
  const ctx = useContext(PayUTokenizeContext);
  return ctx;
}
